export default "__VITE_ASSET__B5a$61pG__"